import React, {useState, useEffect, useRef} from "react";

import "./LandingFeatures.css";
import GraphReportsScatter from "../../tool/graphics/GraphReportsScatter.js";
import GraphReportsBar from "../../tool/graphics/GraphReportsBar.js";
import GraphReportsTS from "../../tool/graphics/GraphReportsTS.js";
import Smiley from "../../tool/graphics/Smiley.js";

import TypeTag from "../../tool/tags/TypeTag.js";

const tagNames = {
    "non-emergent": "Non-Emergent",
    "non-acute": "Non-Acute/Other",
    "refusal": "Refusal",
    "cancelled": "Cancelled/No Patient",
    "general-emergent": "Emergent",
    "interfacility-transfer": "IFT",
    "stroke": "Stroke",
    "arrest": "Arrest",
    "stemi": "STEMI",
    "trauma": "Trauma",
    "respiratory": "Resp",
    "seizure": "Seizure",
    "syncope": "Syncope",
    "tbi": "TBI",
    "pediatrics": "Ped",
    "hypoglycemia": "LBG",
    "airway": "Airway",
    "asthma": "Asthma",
    "patient-death": "Pt Death",
    "narcotics": "Narcs",
    "general-shock": "General Shock",
    "barb-removal": "Barb Removal",
    "infectious-disease": "Infectious Disease",
    "amputation-bleeding": "Amputation/Bleeding",
    "high-risk-refusal": "HRR",
    "tachycardia": "Tachy",
    "bradycardia": "Brady",
    "dialysis": "Dialysis",
    "palliative-care": "Palliative",
    "electrocution": "Electro",
    "drowning-water": "Drowning",
    "hypothermia": "Hypothermia",
    "hyperthermia": "Hyperthermia",
    "alcohol-withdrawl": "Alcohol",
    "epistaxis": "Epistaxis",
    "fever-infection": "Fever",
    "migraine": "Migraine",
    "hyperactive-delirium": "Hyper Delirium",
    "eye-injury": "Eye Injury",
    "hypotension": "Hypotension"
};

const sortedTagNames = Object.fromEntries(
    Object.entries(tagNames).sort()
);

const LandingFeaturesReduced = () => {

    const [currentIndex, setCurrentIndex] = useState(0);
    // store graph components into a useRef so that they only load once
    const componentsRef = useRef([<GraphReportsScatter/>, <GraphReportsBar/>, <GraphReportsTS/>]);

    useEffect(() => { // iterate through the graph components every 5 seconds with index
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % componentsRef.current.length);
        }, 5000);
    
        return () => clearInterval(interval); // Cleanup interval on unmount
    }, []);

    // var header = document.getElementById("feature-header");
    // console.log(header);
    // console.log(document.documentElement);
    
    // document.addEventListener("scroll", function () {
    //     if (header.scrollTop + header.scrollHeight < document.documentElement.scrollTop + document.documentElement.scrollHeight) {

    //     }
    // })

    return (
        <div className="landing-features content" id="demos">
            {/* <h2 id="feature-header">A Two-Stage Approach to EMS Quality</h2> */}
            
            <div className="section-content">

                <div className="qa row qa-row">
                    <div className="col">
                        <img src={require('../../../images/logo-dark-QA.png')} className="logo qalogo "/>
                        {/* <p className="desc">Quality Assurance is necessary for run-to-run compliance. CADMUS QA makes it easier to check over reports by taking care of trivial test cases, saving time and allowing you to focus on the responses that matter most to patients.</p> */}
                        <p className="desc">CADMUS QA significantly reduces the back-and-forth of traditional EMS quality control systems by enabling providers to eliminate documentation errors at the time of writing.</p>
                        <div className="features">
                            <div className="feature">
                                <i className="fa-solid fa-star-of-life"></i>
                                <p>Detects errors in care</p>
                            </div>
                            <div className="feature">
                                <i className="fa-solid fa-dollar-sign"></i>
                                <p>Improves billing</p>
                            </div>
                            <div className="feature">
                                <i className="fa-regular fa-clock"></i>
                                <p>Gives you back time</p>
                            </div>
                            <div className="feature">
                                <i className="fa-solid fa-xmark"></i>
                                <p>No PHI/PII required</p>
                            </div>
                            <div className="feature">
                            <i className="fa-regular fa-square-check"></i>
                                <p>NEMSIS v3.5.1</p>
                            </div>
                        </div>
                        
                    </div>
                    <div className="carousel" style={{paddingTop: '80px'}}>
                        <p className="checks"><strong>Our testing covers a comprehensive set of response cases:</strong></p>
                        <div className="tags">
                            {Object.keys(sortedTagNames).map((type) => (
                                <TypeTag reportType={type} isButton={false}/>
                            ))}
                        </div>
                    </div>
                    {/* <div className="carousel">
                        <div className="images-container">
                            <img src={require('../../../images/qa-screenshot.png')} />
                        </div>
                    </div> */}
                </div>

            </div>
        </div>
    )
}

export default LandingFeaturesReduced; 